import { host, path } from "@Services/url";
import { useDebounceFn, useHover } from "ahooks";
import { Popover } from "antd";
import React, { memo, useEffect, useRef, useState } from "react";
import styled from "styled-components";

interface IProps {
  scrollTopNum: number
  items?: Array<{
    defaultSrc: string;
    hoverSrc: string;
    label: any;
    id: string;
    handleClick?: () => void;
    itemIndex: number
  }>;
}

const { www, c } = host;

const { onlineService } = path;

function HoverImage({ defaultSrc, hoverSrc, isHovering }) {
  return (
    <div
      style={{
        backgroundImage: isHovering ? `url(${hoverSrc})` : `url(${defaultSrc})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        width: '24px',
        height: '24px',
      }}
    />
  );
}


function HoverItem({ defaultSrc, hoverSrc, label, onClick, id }) {
  const ref = useRef<HTMLDivElement>(null);
  const isHovering = useHover(ref);

  const content = <div className="flex flex-col items-center py-20 px-14">
    <img src="https://photo.8891.com.tw/2024/06/18/1718678880203954.png" alt="下載APP" className="w-110 h-110 border-[12px] border-solid border-[#3163FF] rounded-4" />
    <p className="text-14 leading-18 mt-24 text-[#333333]">下載分三步</p>
    <img src="https://photo.8891.com.tw/2024/12/13/1734078004042924.png" alt="" className="w-[276px] h-[68px] ml-14 mt-12" />
  </div>;

  const renderContent = (
    <div className="flex flex-col items-center">
      <HoverImage defaultSrc={defaultSrc} hoverSrc={hoverSrc} isHovering={isHovering} />
      <p className={`text-14 leading-20 w-30 pt-4 leading-16 ${isHovering ? 'text-[#3264FF]' : 'text-[#1D2029]'}`}>
        {label}
      </p>
    </div>
  );

  return (
    <div ref={ref} id={id} className="cursor-pointer" onClick={onClick}>
      {label === '下載APP' ? (
        <Popover placement="left" content={content} trigger="hover" overlayStyle={{ position: 'fixed' }}>
          {renderContent}
        </Popover>
      ) : (
        renderContent
      )}
    </div>
  );
}

const RightFixedBar: React.FC<IProps> = ({ items, scrollTopNum }) => {
  const topRef = useRef(null);
  const isHoverTop = useHover(topRef);
  const [isSticky, setIsSticky] = useState(false);

  const handleMy = async () => {
    try {
      if (!!window.M_ID && window.M_ID !== '0') {
        window.open(`${c}/photoMember-index.html`, '_blank');
      } else {
        window.open(`${www}/user-signin.html?url=${c}/photoMember-index.html`, '_blank');
      }
    } catch (e) {
      console.error(e);
    }
  }

  const handleCustomerService = () => {
    window.open(`${onlineService}?from=newCar`, "serviceWindow", "width=800,height=600");
  }

  const fixedItems = [
    { defaultSrc: 'https://photo.8891.com.tw/2024/11/11/1731308340968171.png', hoverSrc: 'https://photo.8891.com.tw/2024/11/11/1731305235781469.png', label: '我的', id: 'tracking-RightMyBtn' },
    { defaultSrc: 'https://photo.8891.com.tw/2024/11/11/1731308340969099.png', hoverSrc: 'https://photo.8891.com.tw/2024/11/11/1731305235608870.png', label: '客服', id: 'tracking-RightConsultBtn' },
    { defaultSrc: 'https://photo.8891.com.tw/2024/12/11/1733904823716673.png', hoverSrc: 'https://photo.8891.com.tw/2024/12/13/1734077909503512.png', label: "下載APP", id: 'tracking-DownloadAppBtn' },
  ]
  const insertItems = (items, fixedItems) => {
    if (items && !!items.length) {
      items.forEach((item) => {
        fixedItems.splice(item.itemIndex, 0, item);
      });
    }
    return fixedItems;
  };

  const allItems: any = insertItems(items, fixedItems);

  // 滚动监听函数
  const { run: debouncedHandleScroll } = useDebounceFn(
    () => {
      const scrollTop = window.scrollY;
      if (scrollTop > scrollTopNum) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    },
    { wait: 100 }
  );


  useEffect(() => {
    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, []);

  return (
    <section id="tracking-CommonRightFixBar" className="fixed right-0 top-0 bottom-0 my-auto h-[270px] rounded-tl-8 rounded-bl-8 z-999">
      <div
        className={`flex flex-col items-center justify-center py-20 px-12 gap-20 rounded-tl-8 rounded-bl-8 bg-[#fff]`} style={{ boxShadow: '0px 2px 16px 0px rgba(0,0,0,0.10)' }}>
        {allItems.map((item, index) => (
          <HoverItem {...item} key={index} onClick={() => {
            if (item.label === '我的') handleMy?.();
            if (item.label === '客服') handleCustomerService?.();
            item.handleClick?.();
          }} />
        ))}
      </div>
      <div
        className={`mt-8 p-12 rounded-tl-8 rounded-bl-8 bg-[#fff] ${isSticky ? 'visible' : 'hidden'}`}
        style={{ boxShadow: '0px 2px 16px 0px rgba(0,0,0,0.10)' }}
      >
        <div ref={topRef} id="tracking-RightTopBtn" className="flex flex-col items-center justify-center cursor-pointer" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
          <img
            className="w-24 h-24 bg-no-repeat bg-contain"
            src={isHoverTop ? "https://photo.8891.com.tw/2024/11/11/1731305235616267.png" : "https://photo.8891.com.tw/2024/11/11/1731308340891276.png"}
            alt={'置頂'}
          />
        </div>
      </div>
    </section>
  );
};
export default memo(RightFixedBar);
